"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formsV = _interopRequireWildcard(require("@kyruus/forms-v2"));
var _PatientStaticInfo = _interopRequireDefault(require("./PatientStaticInfo"));
var _RegForm = require("../RegForm");
var _utils = require("../../lib/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EhrPatientInfo = _ref => {
  let {
    formBreakpoints,
    ehrPatientDemographics,
    bannerText,
    handleChange,
    handleTrack,
    handleSubmit,
    updatedFields,
    fields,
    isRequiredMarker,
    isNotRequiredMarker,
    disclaimer,
    addOns
  } = _ref;
  const {
    name,
    dob,
    gender,
    address,
    email,
    phones
  } = ehrPatientDemographics;

  // if we have valid demographic data (from ehrPatientDemographics)
  // we don't need a corresponding field for the editable portion of the form
  if ((0, _utils.isValidEHRName)(name)) {
    fields = (0, _filter.default)(fields).call(fields, field => field.type !== 'name');
  }
  if ((0, _utils.isValidEHRDOB)(dob)) {
    fields = (0, _filter.default)(fields).call(fields, field => field.type !== 'dob');
  }
  if ((0, _utils.isValidEHRGender)(gender)) {
    // Gender form fields are type `simpleSelect`, need to use path instead
    fields = (0, _filter.default)(fields).call(fields, field => field.path !== 'patient.gender');
  }
  if ((0, _utils.isValidEHRAddress)(address)) {
    fields = (0, _filter.default)(fields).call(fields, field => field.type !== 'address');
  }
  const phoneConfig = (0, _find.default)(fields).call(fields, field => field.type === 'phone');
  const entityData = {
    patient: {
      email,
      phone: (0, _utils.getPhoneEhrPatientDemographics)(phones, phoneConfig)
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "EhrPatientInfo"
  }, /*#__PURE__*/_react.default.createElement(_PatientStaticInfo.default, {
    name: name,
    dob: dob,
    gender: gender,
    address: address,
    bannerText: bannerText,
    fields: fields
  }), /*#__PURE__*/_react.default.createElement(_formsV.default, {
    breakpoints: formBreakpoints,
    onChange: handleChange,
    onSubmit: handleSubmit,
    onTrack: handleTrack,
    updatedFields: updatedFields,
    fields: fields,
    isRequiredMarker: isRequiredMarker,
    isNotRequiredMarker: isNotRequiredMarker,
    hideDefaultSubmit: true,
    entityData: entityData
  }, (0, _formsV.getAddOns)(addOns, handleTrack), /*#__PURE__*/_react.default.createElement(_formsV.Footer, null, _ref2 => {
    let {
      handleSubmit,
      handleTrack
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_RegForm.RegFormFooterContent, {
      handleSubmit: handleSubmit,
      disclaimer: disclaimer,
      handleTrack: handleTrack
    });
  })));
};
EhrPatientInfo.defaultProps = {
  ehrPatientDemographics: null,
  isRequiredMarker: undefined,
  isNotRequiredMarker: undefined,
  disclaimer: [],
  bannerText: null
};
EhrPatientInfo.propTypes = {
  formBreakpoints: _propTypes.default.shape({
    screen_medium: _propTypes.default.string
  }),
  ehrPatientDemographics: _propTypes.default.shape({
    name: _propTypes.default.shape({
      first: _propTypes.default.string,
      middle: _propTypes.default.string,
      last: _propTypes.default.string
    }),
    dob: _propTypes.default.string,
    gender: _propTypes.default.string,
    address: _propTypes.default.shape({
      street1: _propTypes.default.string,
      street2: _propTypes.default.string,
      city: _propTypes.default.string,
      state: _propTypes.default.string,
      zip: _propTypes.default.string
    }),
    shouldShowBanner: _propTypes.default.bool,
    email: _propTypes.default.string,
    phones: _propTypes.default.arrayOf(_propTypes.default.object)
  }),
  handleChange: _propTypes.default.func.isRequired,
  handleTrack: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  updatedFields: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  fields: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  isRequiredMarker: _propTypes.default.string,
  isNotRequiredMarker: _propTypes.default.string,
  disclaimer: _propTypes.default.arrayOf(_propTypes.default.string),
  bannerText: _propTypes.default.string,
  addOns: _propTypes.default.object
};
var _default = exports.default = EhrPatientInfo;
EhrPatientInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EhrPatientInfo",
  "props": {
    "ehrPatientDemographics": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "name": {
            "name": "shape",
            "value": {
              "first": {
                "name": "string",
                "required": false
              },
              "middle": {
                "name": "string",
                "required": false
              },
              "last": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "dob": {
            "name": "string",
            "required": false
          },
          "gender": {
            "name": "string",
            "required": false
          },
          "address": {
            "name": "shape",
            "value": {
              "street1": {
                "name": "string",
                "required": false
              },
              "street2": {
                "name": "string",
                "required": false
              },
              "city": {
                "name": "string",
                "required": false
              },
              "state": {
                "name": "string",
                "required": false
              },
              "zip": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "shouldShowBanner": {
            "name": "bool",
            "required": false
          },
          "email": {
            "name": "string",
            "required": false
          },
          "phones": {
            "name": "arrayOf",
            "value": {
              "name": "object"
            },
            "required": false
          }
        }
      },
      "required": false
    },
    "isRequiredMarker": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isNotRequiredMarker": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disclaimer": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "bannerText": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "formBreakpoints": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "screen_medium": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "handleChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "handleTrack": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "handleSubmit": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "updatedFields": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "object"
        }
      },
      "required": true
    },
    "fields": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "object"
        }
      },
      "required": true
    },
    "addOns": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};